/**
 * Flight Query Keys
 *
 * Centralized query key factory for React Query cache management
 * Following React Query best practices for key management
 */

import type { FlightListFilters, TelemetryQueryParams } from '../types/flight.types';

export const flightQueryKeys = {
    // Base key for all flight-related queries
    all: ['flights'] as const,

    // List queries
    lists: () => [...flightQueryKeys.all, 'list'] as const,
    list: (filters?: FlightListFilters) => [...flightQueryKeys.lists(), filters] as const,

    // Detail queries
    details: () => [...flightQueryKeys.all, 'detail'] as const,
    detail: (id: string) => [...flightQueryKeys.details(), id] as const,

    // Active flight
    active: () => [...flightQueryKeys.all, 'active'] as const,

    // Telemetry data
    telemetry: (id: string, params?: TelemetryQueryParams) =>
        [...flightQueryKeys.detail(id), 'telemetry', params] as const,

    // Flight path (GeoJSON)
    path: (id: string) => [...flightQueryKeys.detail(id), 'path'] as const,

    // Battery history
    battery: (id: string) => [...flightQueryKeys.detail(id), 'battery'] as const,
};
